import ApiService from "@/services/api.service";
import { MediaAsset, tMediaAsset, tImage, tVideo, Image, Video } from "@/models/media-asset";
import { ISettings } from "@/models/common";
import QS from "qs";
import { ArrayQuery, ListQuery } from "@/services/query-builder";

const api = new ApiService();

class MediaAssetApi {
  public async all(query: { arrayQuery?: ArrayQuery }): Promise<MediaAsset> {
    const queryString = QS.stringify(query);

    return await api.get(`/media-asset/all?${queryString}`);
  }

  public async get(query: ListQuery): Promise<MediaAsset> {
    const queryString = QS.stringify(query);

    return await api.get(`/media-asset?${queryString}`);
  }

  public async find(
    id: number,
    settings: ISettings = { resultKeyOnSuccess: "data", tModel: tMediaAsset }
  ): Promise<MediaAsset> {
    return await api.get(`/media-asset/${id}`, settings);
  }

  public async uploadImage(
    params: FormData,
    settings: ISettings = { resultKeyOnSuccess: "data", tModel: tImage }
  ): Promise<Image> {
    return await api.post("/media-asset/upload/image", params, settings);
  }

  public async uploadVideo(
    params: FormData,
    settings: ISettings = { resultKeyOnSuccess: "data", tModel: tVideo }
  ): Promise<Video> {
    return await api.post("/media-asset/upload/video", params, settings);
  }
}

export default new MediaAssetApi();
